import React, { FC } from "react";
import { FormControl, IconButton, Typography, styled } from "@mui/material";
import theme from "common/theme/theme";
import { GetFormControlSxProps } from "../toolbar/ToolbarSection";

interface IToolbarButtonProps {
  icon: JSX.Element;
  label: string;
  onclick?: () => void;
  disabled?: boolean;
}

export const StyledIconButton = styled(IconButton)`
 margin: auto;
 color: white;
 padding-top: 0px;
 padding-right: 4px;
 padding-left: 4px;
 padding-bottom: 0px;
 &:hover {
    color: ${theme.palette.primary.light};
 }
`;
const ToolbarIconButton: FC<IToolbarButtonProps> = ({ icon, label, onclick, disabled }) => {
  return (
    <FormControl sx={GetFormControlSxProps()}>
      <Typography variant="toolbarlabel">{label}</Typography>
      <StyledIconButton
        onClick={onclick ?? undefined}
        disabled={disabled === true}
      >
        {icon}
      </StyledIconButton>
    </FormControl>
  );
};

export default ToolbarIconButton;
